<div class="cip-left-box">
    <app-casestudy-side-menu [tabs]="tabs" (tabIndexEmit)="getTabIndex($event)" (sideMenuOptionChange)="sectionQuesion($event)"></app-casestudy-side-menu>
</div>
<div class="cip-right-box" *ngIf="!showQuestions">
    <app-casestudy-overview [tabsTitle]="activeTitle" [tabsContent]="activeContent" [active]="active">
    </app-casestudy-overview>
</div>